module.exports = __webpack_public_path__ + "img/TERM-VET-Logo-white.f8fc43e3.svg";